// extracted by mini-css-extract-plugin
export default {"root":"PlasmicVoidStatusCard_root__A3Xvo","text":"PlasmicVoidStatusCard_text__xvApj"};